import Axios from 'axios';
import {urlAPIDirectus} from "../config/globals";

function findAll(){
    return Axios
        .get(urlAPIDirectus+"article?filter[status][_eq]=published&fields=*.*")
        .then(response => response.data.data);
}

export default {
    findAll
}